import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, ClockIcon, MapIcon, BuildingIcon } from 'lucide-react';
import { Seo } from '../components/ui/Seo';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { EnquiryForm } from '../components/contact/EnquiryForm';
import { DISCLAIMER } from '../data/content';
import { COMPANY, ADDRESS_FULL } from '../data/company';
import { IMAGES } from '../data/images';
import { useLanguage } from '../i18n/LanguageContext';
export function Contact() {
  const {
    lang,
    p
  } = useLanguage();
  const c = p.contact;
  return <>
      <Seo title={c.seo.title} description={c.seo.description} data-id="element-386" data-mp="17qqxd2oyvet9" />
      <PageHero eyebrow={c.hero.eyebrow} title={c.hero.title} description={c.hero.description} breadcrumb={c.hero.breadcrumb} image={IMAGES.reception} data-id="element-387" data-mp="12zsdjt4rryl9" />

      <section className="w-full bg-mist py-24 lg:py-32" data-id="element-388" data-mp="ab4k3a9va2wm">
        <div className="mx-auto grid max-w-container gap-12 px-6 lg:grid-cols-12" data-id="element-389" data-mp="aalbwla0qsvs">
          <div className="lg:col-span-7" data-id="element-390" data-mp="15enixfqkrtum">
            <Reveal data-id="element-391" data-mp="15dm5j4m36v9q">
              <EnquiryForm data-id="element-392" data-mp="19gs7i02620ae" />
            </Reveal>
          </div>

          <div className="space-y-6 lg:col-span-5" data-id="element-393" data-mp="19exmklqwa86b">
            <Reveal delay={0.08} data-id="element-394" data-mp="1e7h4fuwm7pgx">
              <div className="rounded-3xl bg-navy p-8" data-id="element-395" data-mp="1e8io2nrp5ka9">
                <h2 className="eyebrow text-gold" data-id="element-396" data-mp="1j73drt9bolkg">{c.officeTitle}</h2>
                <div className="mt-6 flex items-baseline justify-between gap-4" data-id="element-397" data-mp="mgkp8nn318qh">
                  <h3 className="font-display text-xl font-semibold text-white" data-id="element-398" data-mp="minqk3toqoai">
                    {COMPANY.address.province}
                  </h3>
                  <span className="text-[10px] uppercase tracking-widest2 text-gold" data-id="element-399" data-mp="vgzkoftrg47p">
                    {c.officeRole}
                  </span>
                </div>
                <p className="mt-2 text-sm text-navy-100/60" data-id="element-400" data-mp="26weitmxph24e">{COMPANY.legalName}</p>
                <ul className="mt-5 space-y-3 text-sm text-navy-100/70" data-id="element-401" data-mp="26yscbrcqm69u">
                  <li className="flex gap-3" data-id="element-402" data-mp="2btxxgnybfgwv">
                    <MapPinIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-403" data-mp="1m73m3rdjbaaq" />
                    {ADDRESS_FULL[lang]}
                  </li>
                  <li className="flex gap-3" data-id="element-404" data-mp="1h80sd3308qi2">
                    <PhoneIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-405" data-mp="1w62tz7qh71wo" />
                    <a href={`tel:${COMPANY.phoneHref}`} className="transition-colors hover:text-gold" data-id="element-406" data-mp="1r5x15o8gz9d0">
                      {COMPANY.phone}
                    </a>
                  </li>
                  <li className="flex gap-3" data-id="element-407" data-mp="yjlxg4pkgsbz">
                    <MailIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-408" data-mp="1d774uath5dpp" />
                    <a href={`mailto:${COMPANY.email}`} className="transition-colors hover:text-gold" data-id="element-409" data-mp="18ff81ijq6br4">
                      {COMPANY.email}
                    </a>
                  </li>
                </ul>

                <div className="mt-7 border-t border-white/10 pt-6" data-id="element-410" data-mp="fpgou3s7p8ud">
                  <div className="flex items-center gap-3" data-id="element-411" data-mp="2rd20m3c1i1pv">
                    <BuildingIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-412" data-mp="2w5mut5yuygtx" />
                    <h4 className="eyebrow text-gold" data-id="element-413" data-mp="2hgqphgo6rhx0">{c.fiscalTitle}</h4>
                  </div>
                  <dl className="mt-4 space-y-2 text-sm" data-id="element-414" data-mp="2mfabfh2s4tpd">
                    <div className="flex items-center justify-between" data-id="element-415" data-mp="2mfti21mzbvo3">
                      <dt className="text-navy-100/60" data-id="element-416" data-mp="3a65xdxkk0uop">{c.cifLabel}</dt>
                      <dd className="font-medium text-white" data-id="element-417" data-mp="3f4r2aaar42jh">{COMPANY.cif}</dd>
                    </div>
                    <div className="flex items-center justify-between" data-id="element-418" data-mp="314zh9plthlvz">
                      <dt className="text-navy-100/60" data-id="element-419" data-mp="3561ha8nk61z0">{c.vatLabel}</dt>
                      <dd className="font-medium text-white" data-id="element-420" data-mp="3548amtcy3hr0">{COMPANY.vat}</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.16} data-id="element-421" data-mp="1tsfv8wczwghp">
              <div className="rounded-3xl border border-navy-100 bg-white p-8 shadow-soft" data-id="element-422" data-mp="1tojou5bfgors">
                <div className="flex items-center gap-3" data-id="element-423" data-mp="29zu4zsgkka0u">
                  <ClockIcon className="h-4 w-4 text-gold-dark" aria-hidden="true" data-id="element-424" data-mp="256iv1iggnd4p" />
                  <h2 className="eyebrow text-gold-dark" data-id="element-425" data-mp="207fx0hywe768">{c.hoursTitle}</h2>
                </div>
                <dl className="mt-6 space-y-3 text-sm" data-id="element-426" data-mp="1v9wcx1fir06d">
                  {c.hours.map(h => <div key={h.day} className="flex items-center justify-between border-b border-navy-50 pb-3 last:border-0 last:pb-0" data-id="element-427" data-mp="2sx53haudmzf8">
                      <dt className="text-charcoal-light" data-id="element-428" data-mp="2ixnykvmy8pkb">{h.day}</dt>
                      <dd className="font-medium text-navy" data-id="element-429" data-mp="2exdtdl6ze36i">{h.time}</dd>
                    </div>)}
                </dl>
                <p className="mt-5 text-xs leading-relaxed text-charcoal-light" data-id="element-430" data-mp="17kbqg8k5pksc">{c.hoursNote}</p>
              </div>
            </Reveal>

            <Reveal delay={0.24} data-id="element-431" data-mp="13k1iiqct0kau">
              <div className="relative flex h-64 items-center justify-center overflow-hidden rounded-3xl border border-navy-100 bg-navy-50" role="img" aria-label={c.mapLabel} data-id="element-432" data-mp="3f5tzc7vdshe6">
                <div className="absolute inset-0 opacity-60" style={{
                backgroundImage: 'linear-gradient(#E3EAF3 1px, transparent 1px), linear-gradient(90deg, #E3EAF3 1px, transparent 1px)',
                backgroundSize: '32px 32px'
              }} aria-hidden="true" data-id="element-433" data-mp="3o4fhi1wxxuef" />
                <div className="relative px-6 text-center" data-id="element-434" data-mp="asdlg8ki2npo">
                  <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-navy text-gold" data-id="element-435" data-mp="fqoyes63dec4">
                    <MapIcon className="h-5 w-5" aria-hidden="true" data-id="element-436" data-mp="2cjiffb9wo0d6" />
                  </span>
                  <p className="mt-4 font-display text-lg font-semibold text-navy" data-id="element-437" data-mp="2hgqp0ngzmw2t">
                    {COMPANY.addressLine}
                  </p>
                  <p className="mt-1 text-xs uppercase tracking-[0.16em] text-charcoal-light" data-id="element-438" data-mp="3kujzeeadxsol">
                    {c.mapCaption}
                  </p>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.32} data-id="element-439" data-mp="3ou13p4e2sjs6">
              <div className="rounded-3xl border border-navy-100 bg-white p-8" data-id="element-440" data-mp="3otrma573jky3">
                <h2 className="eyebrow text-gold-dark" data-id="element-441" data-mp="7lnt82eedrwm">{c.disclaimerTitle}</h2>
                <p className="mt-4 text-xs leading-relaxed text-charcoal-light" data-id="element-442" data-mp="7jkzb7a4jemm">
                  {DISCLAIMER[lang]}
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </section>
    </>;
}